import axios from 'axios';
import { handleRequestError } from 'requests/requestHandlers';

export const getLinkPreview = (url) => {
  return axios.post('/link_preview', { link: { url } })
    .then(res => res.data)
    .catch(res => handleRequestError(res, 'getLinkPreview'));
};
